export default defineNuxtPlugin((nuxtApp) => {
    if (process.env.NODE_ENV === 'production') {
        const gtmIframe = document.createElement('noscript');
        gtmIframe.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N3G839GH" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.prepend(gtmIframe);
    }
});
